<div [hidden]="!ViewReady" fxLayout="column" fxLayoutAlign="start stretch">
    <h2 class="mat-headline">Requests by {{ User.FirstName | titleCase }} {{ User.LastName | titleCase }}</h2>
    <div>
        The following requests have been created by you in the IRIS system. You may click on the "View" button to view the details of
        the request.
    </div>
    <table
        class="fullwidth"
        [hidden]="!SearchConducted"
        mat-table
        [dataSource]="RequestsData"
        matSort
        matSortActive="RequestIssueNumber"
        matSortDirection="desc"
    >
        <ng-container matColumnDef="RequestIssueNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Request #</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span>{{ req.RequestIssueNumber || '' }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="Subject">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Subject</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span>{{ req.Subject }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="CategoryID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Category</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span>{{ req.CategoryID | category: AllCategories }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="StatusLabel">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Status</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span>{{ req.StatusLabel }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="DateCreated">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Opened</th>
            <td mat-cell *matCellDef="let req" class="centered">
                    <span *ngIf="IsLargeOrWider">{{ req.DateCreated | date: 'M/d/yyyy' }}</span>
                    <span *ngIf="!IsLargeOrWider">{{ req.DateCreated | date: 'M/d/yy' }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="DateClosed">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Closed</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span *ngIf="!req.Completed && !req.Cancelled">N/A</span>
                <span *ngIf="req.Completed || req.Cancelled">
                        <span *ngIf="IsLargeOrWider">{{ req.DateClosed | date: 'M/d/yyyy' }}</span>
                        <span *ngIf="!IsLargeOrWider">{{ req.DateClosed | date: 'M/d/yy' }}</span>
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Actions</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <button type="button" mat-raised-button color="accent" (click)="HandleView(req)">View</button>
            </td>
        </ng-container>

        <ng-container matColumnDef="NoData">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let req" [attr.colspan]="VisibleHeaders?.length">
                <em>There are no requests created by you at this time.</em>
            </td>
        </ng-container>

        <ng-container matColumnDef="SmallDisplay">
            <th mat-header-cell *matHeaderCellDef>My Requests</th>
            <td mat-cell *matCellDef="let req">
                <div fxLayout="column" fxLayoutAlign="start stretch">
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <app-form-label>Request #</app-form-label>
                        <span>{{ req.RequestIssueNumber || '' }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <app-form-label>Subject</app-form-label>
                        <span>{{ req.Subject }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <app-form-label>Category</app-form-label>
                        <span>{{ req.CategoryID | category: AllCategories }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <app-form-label>Status</app-form-label>
                        <span>{{ req.StatusLabel }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <app-form-label>Opened</app-form-label>
                        <span>{{ req.DateCreated | date: 'M/d/yyyy' }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <app-form-label>Closed</app-form-label>
                        <span *ngIf="!req.Completed && !req.Cancelled">N/A</span>
                        <span *ngIf="req.Completed || req.Cancelled">{{ req.DateClosed | date: 'M/d/yyyy' }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center start" class="margin-top margin-bottom">
                        <button type="button" mat-raised-button color="accent" (click)="HandleView(req)">View</button>
                    </div>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="VisibleHeaders"></tr>
        <tr mat-row *matRowDef="let row; columns: VisibleColumns; let $even = even" [class.primarybackground50]="$even"></tr>
    </table>

    <mat-paginator
        #paginator
        [length]="RequestsData?.data?.length"
        [pageIndex]="0"
        [pageSize]="SmallDisplay ? 5 : 10"
        [pageSizeOptions]="[5, 10, 25, 100]"
        [hidden]="!SearchConducted"
    ></mat-paginator>
</div>
